export function user (state) {
    return state.userData
}

export function loginError (state){
    return state.loginError
}